import React, { FC } from 'react'
import { Link, useMatch, useResolvedPath } from 'react-router-dom'
import { IRouteData } from '../../router/RouterData'
import { ImageElement } from '../../router/RouteElement';

interface ILink {
  item: IRouteData;
  itemChild: IRouteData;
  to: string;
}

const CustomLink: FC<ILink> = ({ item, itemChild, to }) => {
  let resolved = useResolvedPath(to)
  let match = useMatch(resolved.pathname)

  // const imagePath = "../" + itemChild.icon

  return (
    <div className="itemChildContainer" key={`${item.path}/${itemChild.path}`}>
      {itemChild.visible && (
        <Link
          to={to}
          key={`${item.path}/${itemChild.path}`}
          className={`itemChild ${match ? 'active' : ''}`}
        >
          <div className="icon-container">
            {ImageElement[itemChild.icon]}
          </div>
          <div className="name">{itemChild.title}</div>
        </Link>)}
    </div>
  )
}

export default CustomLink